export default {
    init() {
        let close_button = document.getElementById('close-key');
        let open_button = document.getElementById('open-key');
        if(close_button) {
            close_button.addEventListener('click', function(event) {
                event.target.parentElement.classList.add('hidden');
                let closed_key = document.querySelector('.key.closed');
                if(closed_key) {
                    closed_key.classList.remove('hidden');
                }
            })
        }

        if(open_button) {
            open_button.addEventListener('click', function(event) {
                event.target.parentElement.classList.add('hidden');
                let opened_key = document.querySelector('.key.open');
                if(opened_key) {
                    opened_key.classList.remove('hidden');
                }
            })
        }

        let curr_page = 1;

        //mobile key.
        let key_mobile = document.getElementById('key-mobile-btn');
        if(key_mobile) {
            //getting each of the pagination buttons.
            let pagination_buttons = {
                left: document.querySelectorAll('.pagination .left'),
                page_1: document.querySelectorAll('.pagination .key-stage-one-btn'),
                page_2: document.querySelectorAll('.pagination .key-stage-two-btn'),
                right: document.querySelectorAll('.pagination .right'),
                exit_buttons: document.querySelectorAll('.close-mobile-key')
            }

            this.pagination_button_action(pagination_buttons.left)
            this.pagination_button_action(pagination_buttons.page_1)
            this.pagination_button_action(pagination_buttons.page_2)
            this.pagination_button_action(pagination_buttons.right)

            //close the key when the close button is clicked.
            if(pagination_buttons.exit_buttons) {
                for(let i = 0; i < pagination_buttons.exit_buttons.length; i++) {
                    let exit_button = pagination_buttons.exit_buttons[i];
                    exit_button.addEventListener('click', (e) => {
                        let modal = document.getElementById('key-mobile-container');
                        if(modal) {
                            modal.classList.add('hidden');

                            //getting the stages, and hiding all except the first.
                            let stages = modal.getElementsByClassName('key-mobile');
                            if(stages) {
                                for(let j = 0; j < stages.length; j++) {
                                    let stage = stages[j];
                                    if(j === 0) {
                                        stage.classList.remove('hidden');
                                    } else {
                                        stage.classList.add('hidden');
                                    }
                                }
                            }
                        }

                    });
                }
            }

            //when the open button is clicked show the mobile key.
            let open_button_mobile = document.getElementById('key-mobile-btn');
            if(open_button_mobile) {
                open_button_mobile.addEventListener('click', (e) => {
                    let modal = document.getElementById('key-mobile-container');
                    if(modal) {
                        modal.classList.remove('hidden');
                    }
                })
            }
        }
    },

    /**
     * Goes through a list of buttons adding an event to change the displayed page
     * @param {HTMLAllCollection} buttons Buttons to add event listener to and change page
     */
    pagination_button_action(buttons) {
        if(buttons) {
            for(let i = 0; i < buttons.length; i++) {
                let btn = buttons[i];

                btn.addEventListener('click', (e) => {
                    let page_val = btn.value;
                    let key_stage_to_show = 'key-stage-' + page_val;

                    //getting each of the key stages
                    for(let i = 1; i < 3; i++) {
                        let the_key_stage = 'key-stage-' + i;
                        let key_stage_el = document.getElementById(the_key_stage);

                        //showing the selected stage and hiding the others.
                        if(the_key_stage !== key_stage_to_show) {
                            if(key_stage_el) {
                                key_stage_el.classList.add('hidden');
                            }
                        } else {
                            if(key_stage_el) {
                                key_stage_el.classList.remove('hidden');  
                            }                          
                        }
                    }
                })
            }
        }

        //returning what the new page is.
    },
}